<app-card-box>
    <div class="g-card-box" header>
        <div class="g-card-box-row">
            <div class="g-card-box-title">
                {{ otdScansTexts.title }}
            </div>
            <app-upload-file
                #otdScanFileUpload
                hidden
                (change)="onFileChanged(otdScanFileUpload)"
                [appMaxFileSizeValidator]="50"
                [formControl]="fileControl"
                maxUnitType="MB"
                [appId]="AppIdsEnum.upload_otd_scans_file_button"
                accept=".otdr,.otds"
            >
            </app-upload-file>

            <div>
                <app-ui-button [size]="'small'" [label]="this.texts.general.buttons.upload" [isDisabled]="isDisabled"
                               (clicked)="uploadFile()" [isLoadingState]="isLoading()">
                </app-ui-button>
            </div>
        </div>

        <div class="g-card-box-sub-title g-margin-top-15">
            <p>{{ otdScansTexts.description }}</p>
        </div>

        <app-notification [type]="toasterType.Warning">
            {{ otdScansTexts.overlapping_ips_warning }}
        </app-notification>
    </div>
</app-card-box>
